const init_advertisement_tag = {
  title: '',
  remarks: '',
};

export default init_advertisement_tag;
